import styled from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from 'theme';

export const StyledPostHeader = styled.section`
  display: grid;
  margin-top: ${spacing('xl')};
  grid-template-areas:
    'tags tags'
    'title thumb'
    'meta  thumb';
  grid-template-columns: 1fr 45%;
  grid-template-rows: auto auto auto;
  gap: 0 40px;
  align-items: normal;

  @media (max-width: ${screen('lg')}) {
    grid-template-areas:
      'title'
      'tags'
      'meta'
      'thumb';
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;
    padding-bottom: 24px;
    gap: 0;
  }
`;
export const StyledHeaderContent = styled.div`
  display: contents;
  align-items: center;
  justify-content: center;
`;

export const StyledHeaderTags = styled.div`
  grid-area: tags;
  justify-self: start;
  margin-bottom: ${spacing('xs')};
`;
export const StyledHeaderTitle = styled.h1`
  font-family: ${fontFamily('serif')};
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('xl5')};
  line-height: 1.17;

  grid-area: title;
  color: #2d2d3a;
  margin: ${spacing('md')} 0;
  line-height: 1.15;

  @media (max-width: ${screen('lg')}) {
    margin: 24px 0 16px 0;
    font-size: 2rem;
    line-height: 1.2;
  }
`;

export const StyledHeaderThumb = styled.div`
  grid-area: thumb;
  display: flex;
  align-items: start;
  justify-content: center;
  overflow: hidden;
  min-block-size: 0;
  height: 100%;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    mask-image: url('/images/blog/irregular-box-white.svg');
    mask-size: 100% 100%;
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-image: url('/images/blog/irregular-box-white.svg');
    -webkit-mask-size: 100% 100%;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
  }

  @media (max-width: ${screen('lg')}) {
    justify-self: center;
    margin-top: 24px;
  }
`;

export const StyledHeaderAuthorName = styled.a`
  color: ${color('emerald_600')};
  font-weight: ${fontWeight('semiBold')};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledHeaderMetaTable = styled.div`
  grid-area: meta;
  display: grid;
  grid-template-areas: 'author published updated readtime';
  grid-template-columns: repeat(4, max-content);
  column-gap: 24px;
  row-gap: 16px;
  margin-top: 16px;
  align-items: center;

  @media (max-width: ${screen('md')}) {
    grid-template-areas:
      'author readtime'
      'published updated';
    grid-template-columns: repeat(2, max-content);
  }

  @media (max-width: ${screen('sm')}) {
    grid-template-areas:
      'author author'
      'published updated'
      'readtime readtime';
    grid-template-columns: repeat(2, max-content);
  }
`;

export const MetaEntry = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const MetaAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
`;

export const MetaText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const MetaTitle = styled.span`
  font-size: 0.85rem;
  font-weight: ${fontWeight('medium')};
  color: #6b6b7b;
  margin-bottom: 2px;
  white-space: nowrap;
`;

export const MetaValue = styled.span`
  font-size: 0.95rem;
  font-weight: ${fontWeight('semiBold')};
  color: #2d2d3a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AuthorEntry = styled(MetaEntry)`
  grid-area: author;
`;
export const PublishedEntry = styled(MetaEntry)`
  grid-area: published;
`;
export const UpdatedEntry = styled(MetaEntry)`
  grid-area: updated;
`;
export const ReadTimeEntry = styled(MetaEntry)`
  grid-area: readtime;
`;
